<script>
    import FeatureTable from "../Misc/WPNFeatureTable.svelte";
    import schemaData from "../../Stores/wpn2SchemaStore.js"
    import { specificAttributesForItem, textForKeyData } from "../../scripts/wpn2Model.js";

    export let item;
    let itemInfo;

    $: itemInfo = specificFeaturesForItem(item);

    function specificFeaturesForItem(item) {
        const specAttrs = specificAttributesForItem(item) ?? [];
        const isAttrs = specAttrs.filter((x) => item[x] != undefined);
        var featureInfo = $schemaData['keysList'].filter(x => isAttrs.includes(x.key)) ?? [];
        featureInfo.forEach(x => x.value = textForKeyData(x, item, "Unknown") ?? "");
        return featureInfo;
    }
</script>

{#if itemInfo.length > 0}
    <div class="detail-section">
        <div class="detail-section-title">Data</div>
        <FeatureTable {itemInfo} />
    </div>
{/if}
